import { Users } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';

export const AdminUsersTab = () => {
  const { users } = useAdmin();

  return (
    <Card className="bg-card border-border">
      <CardHeader><CardTitle className="flex items-center gap-2"><Users size={20} /> Registered Users ({users.length})</CardTitle></CardHeader>
      <CardContent>
        {users.length === 0 ? (
          <p className="text-muted-foreground text-center py-4">No registered users</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left py-3 px-2 text-sm font-medium">Email</th>
                  <th className="text-left py-3 px-2 text-sm font-medium">Name</th>
                  <th className="text-left py-3 px-2 text-sm font-medium">Role</th>
                  <th className="text-left py-3 px-2 text-sm font-medium">Joined</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, idx) => (
                  <tr key={idx} className="border-b border-border/50 hover:bg-muted/50">
                    <td className="py-3 px-2 text-sm">{user.email}</td>
                    <td className="py-3 px-2 text-sm">{user.name || '-'}</td>
                    <td className="py-3 px-2">
                      <span className={`text-xs px-2 py-1 rounded-full ${user.role === 'admin' ? 'bg-yellow-500/20 text-yellow-500' : user.role === 'artist' ? 'bg-purple-500/20 text-purple-500' : 'bg-blue-500/20 text-blue-500'}`}>
                        {user.role}
                      </span>
                    </td>
                    <td className="py-3 px-2 text-sm text-muted-foreground">{user.created_at ? new Date(user.created_at).toLocaleDateString() : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
